<template>
	<div class="top">
		<div class="examUser">
			<img src="../../../../../../static/images/testImgs/userImg.png">
			<div class="right_msg">
				<p><span>姓名：</span>{{name}}</p>
				<p><span>性别：</span>{{sex == '1'?'男':'女'}}</p>
				<p><span>准考证号：</span>11111111111111</p>
				<p><span>证件号码：</span>11111111111111</p>
			</div>
		</div>
		<div class="exam_subject">
			<span>{{this.$route.query.paperName}}</span>
		</div>
		<div class="exam_time">
			<b class="downTime">科目剩余时间：{{countDown}} </b>
			<span v-if="!this.showBack" @click="submitTest">交卷</span>
			<!-- <span style="background:white;color:rgba(131,182,255,1);border-color:white; " v-if="this.showBack" @click="back">返回</span> -->
		</div>
	</div>

</template>

<script>
	import * as api from "../../../../../api/testExamApi";
	import {
		moduleId
	} from "../../../../../store/modules/exam";
	import {
		mapState,
		mapMutations,
		mapActions,
		mapGetters
	} from 'vuex';
	export default {
		data() {
			return {
				countDown: null,
				examCardno: null,
				downTime: null,
				flag: 0, //跳转到交卷  如果flag是0 是时间到 1 是手动交卷
				name: sessionStorage.getItem('loginName'),
				sex: sessionStorage.getItem('sex')
			}
		},
		computed: {
			...mapState(moduleId, {
				paperData: state => state.paperData,
				showBack: state => state.showBack,
				isShowLeft: state => state.isShowLeft,
			}),
		},
		watch: {
			paperData: {
				handler(val) {
					if(val) {
						if (this.$route.query.type == 1) {
							let endTime = new Date(val.examPaper.startAnswerTime.replace(/-/g,'/')).getTime() + val.examCourse.examTime * 60 *
								1000;
							let currentTime = new Date(val.examPaper.currentDate.replace(/-/g,'/')).getTime();
							if (endTime >= currentTime) {
								this.downTime = endTime - currentTime;
								window.time = setInterval(() => {
									if (this.downTime <= 0) {
										clearInterval(window.time);
										this.flag = 0;
										this.submitPaper();
									}
									this.countDown = this.countTime(this.downTime - 1000);
									this.downTime = this.downTime - 1000;
								}, 1000);
							} else {
								//跳转到交卷  如果flag是0 是时间到 1 是手动交卷
								this.flag = 1;
								this.submitPaper();
							}

						}
					}
				},
				immediate: true,
				deep: true,
			}
		},
		methods: {
			...mapMutations(moduleId, ['SHOW_OPTIONS', 'SHOW_BACK', 'SHOW_LEFT']),
			save() {
				this.$messageSuccess("答案保存成功！")
			},
			back() {
				$(".content_box").css("flex-direction", "column");
				$("#wrapMain").css({
					"height": "100%",
					"width": "100%",
				});
				this.SHOW_OPTIONS(false);
				this.SHOW_BACK(false);
				this.SHOW_LEFT(true);
			},
			countTime(value) {
				var differTime = value;
				//定义变量,h,m,s保存倒计时的时间
				var h, m, s;
				if (differTime >= 0) {
					h = Math.floor(differTime / 1000 / 60 / 60);
					m = Math.floor(differTime / 1000 / 60 % 60);
					s = Math.floor(differTime / 1000 % 60);
					h = h < 10 ? ("0" + h) : h;
					m = m < 10 ? ("0" + m) : m;
					s = s < 10 ? ("0" + s) : s;
					var timeDom = h + " : " + m + " : " + s;
					return timeDom;
					//递归调用函数所以是延时器不是定时器

				}
			},
			submitTest() {
				api.submitTestNew(this.paperData.examPaperId, this.$route.query.paperId).then((result) => {
					if (result.code === "1") {
						const h = this.$createElement;
						this.$msgbox({
							title: '交卷确认',
							message: h('p', null, [
								h('span', null,
									`共${result.data.count}题，已答${result.data.finish}题， 未答`),
								h('i', {
									style: 'color: red'
								}, ` ${result.data.notFinish}`),
								h('span', null, ' 题'),
							]),
							showCancelButton: true,
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
							this.submitPaper();
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消'
							});
						});
					} else if (result.code === "2") {
						const h = this.$createElement;
						this.$msgbox({
							title: '交卷确认',
							message: h('p', null, [
								h('span', null, `作答已完成`),
							]),
							showCancelButton: true,
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
							this.submitPaper();
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消'
							});
						});
					} else if (result.code === "3") {
						this.$messageError(result.msg)
					}
				});
			},
			submitPaper() {
				if (window.time) {
					clearInterval(window.time)
				}
				api.submitExamNew(this.paperData.examPaperId).then((result) => {
					if (result.code === "0") {
						// this.$messageSuccess("交卷成功！");

						let obj = {
							catalogId: this.$route.query.catalogId, //当前学习的目录id 
							courseId: this.$route.query.id, //课程id
							resourceId: Number(this.$route.query.paperId), //当前学习的资源id
							classId: this.$route.query.classId,
							isEnd: 1, // 0 未看完，1，已看完 。资源是否看完
							seatno: 1, //资源学习次数
							resProgress: 1, //这条资源最后一次学习的时间
							totalResNum: 0, //总资源数
							resourceType: 5
						};
						console.log(obj);
						this.insertDirectory(obj);
						if (this.flag == 0) {
							this.$router.push({
								path: '/switch/test/successNew',
								query: {
									id: this.$route.query.id,
									classId: this.$route.query.classId,
									userId: sessionStorage.getItem('userId'),
									paperId: this.$route.query.paperId,
									total: this.$route.query.total,
									className: this.$route.query.className,
									catalogId: this.$route.query.catalogId,
									paperCode: this.$route.query.paperCode,
									examId: this.$route.query.examId,
									flag: result.data,
									value: 0,
									finishFlag: 0
								}
							});
						} else {
							this.$router.push({
								path: '/switch/test/successNew',
								query: {
									id: this.$route.query.id,
									classId: this.$route.query.classId,
									userId: sessionStorage.getItem('userId'),
									paperId: this.$route.query.paperId,
									total: this.$route.query.total,
									className: this.$route.query.className,
									catalogId: this.$route.query.catalogId,
									paperCode: this.$route.query.paperCode,
									examId: this.$route.query.examId,
									flag: result.data,
									value: 1,
									finishFlag: 0
								}
							});
						}

					}
				})
			},
			insertDirectory(data) {
				api.addToResRecord(data).then(rs => {
						// console.log(rs);
					})
					.catch(function(error) {
						console.log(error);
					});
			},
		},
		mounted() {

		}
	}
</script>

<style lang="scss" scoped>
	.top {
		width: 100%;
		height: 100px;
		line-height: 100px;
		background: #74B6F5;
		display: flex;
		justify-content: space-between;

		.examUser {
			width: 275px;
			display: flex;
			justify-content: start;
			align-items: center;

			img {
				display: inline-block;
				width: 70px;
				height: 90px;
				margin-left: 5px;
			}

			.right_msg {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				height: 88px;
				margin-left: 8px;

				p {
					font-size: 14px;
					color: #fff;
					line-height: 19px;
				}
			}
		}

		.exam_subject {
			color: rgba(255, 255, 255, 1);
			padding-left: 20px;
			font-size: 16px;
		}

		.name {
			color: rgba(255, 255, 255, 1);

			span:nth-child(1) {
				font-size: 14px;
			}

			span:nth-child(2) {
				font-size: 16px;
			}
		}

		.exam_number {
			color: rgba(255, 255, 255, 1);
			text-align: center;

			span:nth-child(1) {
				font-size: 14px;
			}

			span:nth-child(2) {
				font-size: 16px;
			}
		}

		.exam_time {
			span {
				width: 80px;
				height: 30px;
				text-align: center;
				line-height: 30px;
				display: inline-block;
				color: #000000;
				background: url(../../../../../../static/images/testImgs/btn.png) no-repeat 100%;
				cursor: pointer;
				margin-right: 48px;
			}
		}
	}

	.downTime {
		opacity: 1;
		height: 30px;
		border-radius: 24px;
		font-size: 16px;
		color: #FFFF00;
		margin-right: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testSumulationComponentNew/header.vue